(function () {
  var SELECTOR = [
    '.main-product .product__media',
    '.product__bottom-info img',
    '.collapsible-content img',
    '.rich-text img',
    '.card-wrapper',
    '.card:not(.card-wrapper .card)'
  ].join(',');

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var items = document.querySelectorAll(SELECTOR);
    if (!items.length) return;

    var observer = new IntersectionObserver(
      function (entries, obs) {
        var batch = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          obs.unobserve(el);
          if (el.hasAttribute('data-pdp-popped')) return;
          el.setAttribute('data-pdp-popped', '');
          /* Stagger elements that appear in the same instant. */
          el.style.setProperty('--pdp-pop-delay', Math.min(batch, 4) * 70 + 'ms');
          batch += 1;
          el.classList.add('pdp-pop');
        });
      },
      { threshold: 0.15 }
    );

    items.forEach(function (el) {
      if (el.hasAttribute('data-pdp-popped')) return;
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  var recs = document.querySelector('product-recommendations');
  if (recs && 'MutationObserver' in window) {
    var recsWatcher = new MutationObserver(function () {
      if (recs.querySelector('.card-wrapper')) {
        recsWatcher.disconnect();
        init();
      }
    });
    recsWatcher.observe(recs, { childList: true, subtree: true });
  }
})();
